import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const createAssetValidation = yup.object().shape({
    name: yup.string().required(ERRORS.required),
    description: yup.string().optional(),
});
